export enum TaskSteps {
  GOING_TO_DESTINATION = 'GOING_TO_DESTINATION',
  GOING_TO_ORIGIN = 'GOING_TO_ORIGIN',
  CHECKING_OUT = 'CHECKING_OUT',
  TRANSFERRING_FROM = 'TRANSFERRING_FROM',
  FINISHED = 'FINISHED',
  DELIVERING = 'DELIVERING',
  TRANSFERRING_TO = 'TRANSFERRING_TO',
  PICKING = 'PICKING',
  TRANSFERRING_FROM_PICKING_TO_STORAGE = 'TRANSFERRING_FROM_PICKING_TO_STORAGE',
  TRANSFERRING_TO_STORAGE_FROM_PICKING = 'TRANSFERRING_TO_STORAGE_FROM_PICKING',
  STORING = 'STORING',
  TRANSFERRING_FROM_STORAGE_TO_DELIVERY = 'TRANSFERRING_FROM_STORAGE_TO_DELIVERY',
  TRANSFERRING_TO_DELIVERY_FROM_STORAGE = 'TRANSFERRING_TO_DELIVERY_FROM_STORAGE',
  EXECUTION_DONE = 'EXECUTION_DONE',
  CANCELED = 'CANCELED'
}

export const TaskStepsColors = {
  GOING_TO_DESTINATION: { bg: '#3ACF3A', text: '#FFFFFF' },
  GOING_TO_ORIGIN: { bg: '#FFC078', text: '#2C2E30' },
  CHECKING_OUT: { bg: '#FFE066', text: '#2C2E30' },
  TRANSFERRING_FROM: { bg: '#FCC419', text: '#2C2E30' },
  FINISHED: { bg: '#2B8A3E', text: '#FFFFFF' },
  DELIVERING: { bg: '#37B24D', text: '#FFFFFF' },
  TRANSFERRING_TO: { bg: '#FCC419', text: '#2C2E30' },
  PICKING: { bg: '#FD7E14', text: '#2C2E30' },
  TRANSFERRING_FROM_PICKING_TO_STORAGE: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_TO_STORAGE_FROM_PICKING: { bg: '#FCC419', text: '#2C2E30' },
  STORING: { bg: '#F59F00', text: '#2C2E30' },
  TRANSFERRING_FROM_STORAGE_TO_DELIVERY: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_TO_DELIVERY_FROM_STORAGE: { bg: '#FCC419', text: '#2C2E30' },
  EXECUTION_DONE: { bg: '#2B8A3E', text: '#FFFFFF' },
  CANCELED: { bg: '#D94444', text: '#FFFFFF' },
  RE_ALLOCATED: { bg: '#ADB5BD', text: '#FFFFFF' },
  RESET: { bg: '#ADB5BD', text: '#FFFFFF' },
  RESCHEDULED: { bg: '#ADB5BD', text: '#FFFFFF' }
}
